export const PPDB_CTA_DEFAULTS = {
  hero: "Pendaftaran PPDB",
  navbar: "PPDB / Pendaftaran",
  section: "Daftar PPDB Online",
  sidebar: "Daftar PPDB Online",
  page: "Daftar Online Sekarang",
};
